import { render, staticRenderFns } from "./GroupSessionsScroller.vue?vue&type=template&id=0cc3d1c2&scoped=true&"
import script from "./GroupSessionsScroller.vue?vue&type=script&lang=js&"
export * from "./GroupSessionsScroller.vue?vue&type=script&lang=js&"
import style0 from "./GroupSessionsScroller.vue?vue&type=style&index=0&id=0cc3d1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3d1c2",
  null
  
)

export default component.exports